<template>
	<div class="partner-info">
		<loading v-if="loading"></loading>
		<div v-else class="is-flex">
			<router-link
				:to="{ name: '_partnerProfile', params: { Id: userId || user.Id } }"></router-link>
			<user-picture
				:user="activeUser"
				size="large"
				v-if="activeUser"
				@click="navigateToPartnerProfile"
				class="clickable"></user-picture>
			<div v-if="activeUser" class="is-flex is-flex-direction-column">
				<div class="mt-2">
					<h3>{{ activeUser.FirstName }} {{ activeUser.LastName }}</h3>
					<div>{{ activeUser.Title }}</div>
					<div>
						<div v-for="location in activeUser.Locations" :key="location.Id">
							{{ location.Name }}
						</div>
					</div>
				</div>
				<div class="mt-4">
					<div>
						<!-- {{ activeUser.OfficePhone }} -->
						<a :href="'tel:' + activeUser.OfficePhone">{{ activeUser.OfficePhone }}</a>
					</div>
					<div>
						<a :href="'mailto:' + activeUser.Email" v-html="FormatEmail(activeUser.Email)"></a>
						<!-- {{ activeUser.Email }} -->
					</div>
				</div>
			</div>
			<div v-else>
				<skeleton-detail></skeleton-detail>
			</div>
		</div>
	</div>
</template>
<script>
	import { ref, inject } from "vue";
	import { skeletonDetail } from "@/components/webComponents/template";
	export default {
		components: {
			skeletonDetail
		},
		props: {
			userId: {
				type: [String, Number],
				default: undefined
			},
			user: {
				type: Object,
				default: () => {
					return undefined;
				}
			}
		},
		methods: {
			navigateToPartnerProfile() {
				this.$router.push({ name: "_partnerProfile", params: { Id: this.userId || this.user.Id } });
			}
		},
		setup(props, context) {
			const $http = inject("$http");

			const loading = ref(true);

			const FormatEmail = (email) => {
				if (!email) return "";
				const parts = email.split("@");
				return parts[0] + "<wbr>@" + parts[1];
			};

			const activeUser = ref(props.user);
			if (!props.user) {
				loading.value = true;
				$http.get("/api/v2/partner/" + props.userId + "/new").then((resp) => {
					activeUser.value = resp.data;
					loading.value = false;
				});
			}

			return {
				loading,
				FormatEmail,
				activeUser
			};
		}
	};
</script>

<style scoped>
	.clickable {
		cursor: pointer;
	}
</style>